const Footer = () => {
  return (
    <footer className="w-full py-4 mt-auto border-t border-gray-100 bg-white/50">
      <div className="text-center text-sm text-gray-500">
        Developed & Maintained By{" "}
        <a
          href="https://www.nitlimited.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-teal-600 hover:text-teal-700 hover:underline font-medium"
          data-testid="footer-link"
        >
          Nusite IT Consulting Ltd.
        </a>
      </div>
    </footer>
  );
};

export default Footer;
